import layout from '@/components/common/layout';
import lmoduleList from '../views/lmodule/list';
import lmoduleCreate from "../views/lmodule/create";

export default [
    {
        path: '/lmodule',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "模块列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lmoduleList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增模块",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lmoduleCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑模块",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lmoduleCreate,
            },
        ]
    },
];
